import { t } from "translations"

import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

enum SortValue {
    BEST_HITS,
    DATE
}

export default function SearchRadioGroup({
    updateSortType,
    sortValue
}: {
    updateSortType: (sortOnDate: number) => void
    sortValue: number
}) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateSortType(parseInt(event.target.value))
    }

    return (
        <StyledFormControl>
            <FormLabel>
                <StyledFormLabel variant="subtitle2">
                    {t.search.sortSearch}
                </StyledFormLabel>
            </FormLabel>
            <StyledRadioGroup
                name="controlled-radio-buttons-group"
                value={sortValue}
                onChange={e => handleChange(e)}>
                <FormControlLabel
                    value={SortValue.BEST_HITS}
                    control={<StyledRadio color="secondary" />}
                    label={
                        <Typography variant="subtitle2">
                            {`${t.search.bestHist}`}
                        </Typography>
                    }
                />
                <FormControlLabel
                    value={SortValue.DATE}
                    control={<StyledRadio color="secondary" />}
                    label={
                        <Typography variant="subtitle2">
                            {`${t.search.date}`}
                        </Typography>
                    }
                />
            </StyledRadioGroup>
        </StyledFormControl>
    )
}

const StyledFormControl = styled(FormControl)(() => ({
    minWidth: "fit-content"
}))

const StyledFormLabel = styled(Typography)(() => ({
    color: "black",
    fontWeight: 600
}))

const StyledRadioGroup = styled(RadioGroup)(() => ({
    display: "flex",
    flexDirection: "row"
}))

const StyledRadio = styled(Radio)(({ theme }) => ({
    paddingRight: theme.spacing(0.5)
}))
